import {SubRole, SystemRole} from "../_models/user";
import {CompanyType} from "../_models/company";
import {Task, TaskDueDate, TaskPriority, TaskStatus, TaskType} from "../_models/task";
import {KeyValue} from "@angular/common";
import {Area, AreaStatus} from "../_models/area";
import {moveItemInArray} from "@angular/cdk/drag-drop";
import {OrderStatus, SubmittalStatus} from "../_models/material";
import {DocumentType} from "../_models/document";
import {MyTaskFilter} from "../components/admin/components/my-tasks/my-tasks.component";
import {Floor} from "../_models/floor";
import {Room} from "../_models/room";
import {LinkedElementType} from "../_models/linked-element";
import {Unit} from "../_models/unit";
import {EntityTypeWithTabs} from "../_models/entityWithTabs";
import {Project} from "../_models/project";

export function convertSystemRoleToEnum(systemRole: any): SystemRole {
  return SystemRole[systemRole as unknown as keyof typeof SystemRole];
}
export function convertSubRoleToEnum(subRole: any): SubRole {
  return SubRole[subRole as unknown as keyof typeof SubRole];
}

export function convertCompanyTypeToEnum(companyType: any): CompanyType {
  return CompanyType[companyType as unknown as keyof typeof CompanyType];
}

export function convertTaskStatusToEnum(taskStatus: any): TaskStatus {
    return TaskStatus[taskStatus as unknown as keyof typeof TaskStatus];
}

export function convertTaskTypeToEnum(taskType: any): TaskType {
  return TaskType[taskType as unknown as keyof typeof TaskType];
}

export function convertTaskDueDateToEnum(taskDueDate: any): TaskDueDate {
  return TaskDueDate[taskDueDate as unknown as keyof typeof TaskDueDate];
}

export function convertTaskPriorityToEnum(taskPriority: any): TaskPriority {
    return TaskPriority[taskPriority as unknown as keyof typeof TaskPriority];
}

export function convertMyTaskFiltersToEnum(myTaskFilter: any): MyTaskFilter {
  return MyTaskFilter[myTaskFilter as unknown as keyof typeof MyTaskFilter];
}

export function convertAreaStatusToEnum(areaStatus: any): AreaStatus {
  return AreaStatus[areaStatus as unknown as keyof typeof AreaStatus];
}

export function convertIdToNumber(input: any): number {
  if (!Number.isNaN(Number.parseInt(input))) return Number.parseInt(input);
  else return 0;
}

export function convertDocumentTypeToEnum(documentType: any): DocumentType {
  return DocumentType[documentType as unknown as keyof typeof DocumentType];
}

export function convertMaterialOrderStatusToEnum(materialOrderStatus: any): OrderStatus {
  return OrderStatus[materialOrderStatus as unknown as keyof typeof OrderStatus];
}

export function convertMaterialSubmittalStatusToEnum(materialSubmittalStatus: any): SubmittalStatus {
  return SubmittalStatus[materialSubmittalStatus as unknown as keyof typeof SubmittalStatus];
}

export function getScrollParents(el: HTMLElement): Array<HTMLElement | Window> {
  const parents: Array<HTMLElement | Window> = [];
  let parent: HTMLElement | null = el.parentElement;

  while (parent) {
    const style = getComputedStyle(parent);
    const overflow = style.overflow + style.overflowY + style.overflowX;
    if (/(auto|scroll)/.test(overflow)) {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }

  parents.push(window);
  return parents;
}

export const originalOrder = (a: KeyValue<any,any>, b: KeyValue<any,any>): any => {
    return 0;
}

export function waitForElm(selector: string) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) return resolve(document.querySelector(selector));

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

export function moveItemInArrayCopyAndUpdateVersion(newOrder: number, oldOrder: number, array: any[]) {
  const updatedArray = [...array];

  moveItemInArray(updatedArray, oldOrder, newOrder);

  for (let i = Math.min(oldOrder, newOrder); i <= Math.max(oldOrder, newOrder); i++) {
    if (updatedArray[i].orderNumber !== i) {
      updatedArray[i].orderNumber = i;
      updatedArray[i].version++;
    }
  }

  return updatedArray;
}

export function getFilenameFromDisposition(contentDisposition: string | null): string {
  let filename = 'download.xlsx';
  if (contentDisposition) {
    const matches = /filename\*=(?:UTF-8'')?([^;]+)|filename="?([^"]+)"?/.exec(contentDisposition);
    if (matches) {
      filename = decodeURIComponent(matches[1] || matches[2]).replace(/['"]/g, '');
    }
  }
  return filename;
}


//Elements

export function isProject(obj: any): obj is Project {
  return obj && obj.type === LinkedElementType.PROJECT_ELEMENT;
}

export function isFloor(obj: any): obj is Floor {
  return obj && obj.type === LinkedElementType.FLOOR_ELEMENT;
}

export function isUnit(obj: any): obj is Unit {
  return obj && obj.type === LinkedElementType.UNIT_ELEMENT;
}

export function isRoom(obj: any): obj is Room {
  return obj && obj.type === LinkedElementType.ROOM_ELEMENT;
}

export function getAsRoom(obj: any): Room {
  return obj as Room;
}

export function isArea(obj: any): obj is Area {
  return obj && obj.type === LinkedElementType.AREA_ELEMENT;
}


export function getLinkedElementsIdsAndNames(element: EntityTypeWithTabs) {
  let obj: {
    companyId: number;
    projectId: number;
    floorId: number;
    floorName: string;
    floorEndDate?: string;
    unitId: number;
    unitName: string;
    unitEndDate?: string;
    roomId: number;
    roomName: string;
    roomEndDate?: string;
    roomAreaId: number;
    roomAreaName: string;
    roomAreaEndDate?: string;
  } = {
    companyId: null,
    projectId: null,
    floorId: null,
    floorName: null,
    floorEndDate: null,
    unitId: null,
    unitName: null,
    unitEndDate: null,
    roomId: null,
    roomName: null,
    roomAreaName: null,
    roomAreaId: null,
    roomAreaEndDate: null,
  }
  if(isFloor(element)) {
    obj.companyId = element.project?.company?.id;
    obj.projectId = element.project?.id;
    obj.floorId = element.id;
    obj.floorName = element.name
    obj.floorEndDate = element.endDate
  }
  if(isUnit(element)) {
    element = element as unknown as Unit;
    obj.companyId = element.floor.project?.company?.id;
    obj.projectId = element.floor.project?.id;
    obj.floorId = element.floor.id
    obj.floorName = element.floor.name
    obj.unitId = element.id;
    obj.unitName = element.name
    obj.unitEndDate = element.endDate
  }
  if(isRoom(element)) {
    element = element as unknown as Room;
    obj.companyId = element.unit.floor.project?.company?.id;
    obj.projectId = element.unit.floor.project?.id;
    obj.floorId = element.unit.floor.id
    obj.floorName = element.unit.floor.name
    obj.unitId = element.unit.id
    obj.unitName = element.unit.name
    obj.roomId = element.id
    obj.roomName = element.name
    obj.roomEndDate = element.endDate
  }
  if(isArea(element)) {
    obj.companyId = element.room.unit.floor.project?.company?.id;
    obj.projectId = element.room.unit.floor.project?.id;
    obj.floorId = element.room.unit.floor.id
    obj.floorName = element.room.unit.floor.name
    obj.unitId = element.room.unit.id
    obj.unitName = element.room.unit.name
    obj.roomId = element.room.id
    obj.roomName = element.room.name
    obj.roomAreaId = element.id
    obj.roomAreaName = element.name
    obj.roomAreaEndDate = element.endDate
  }

  return obj;
}
export function convertToLinkedElementType(elementType: string) {
  return elementType as LinkedElementType
}

export function detectElementType(id: string): LinkedElementType | null {
  const suffix = id.split('-')[1];

  if (!suffix) return null;

  const typeChar = suffix.charAt(0).toUpperCase();

  switch (typeChar) {
    case 'F':
      return LinkedElementType.FLOOR_ELEMENT;
    case 'U':
      return LinkedElementType.UNIT_ELEMENT;
    case 'R':
      return LinkedElementType.ROOM_ELEMENT;
    default:
      if (/^\d/.test(suffix)) {
        return LinkedElementType.AREA_ELEMENT;
      }
      return null;
  }
}

export function setElementType(type: string): LinkedElementType | null {

  switch (type.toLowerCase()) {
    case 'all types': return null;
    case 'floor':
      return LinkedElementType.FLOOR_ELEMENT;
    case 'unit':
      return LinkedElementType.UNIT_ELEMENT;
    case 'room':
      return LinkedElementType.ROOM_ELEMENT;
    default:
        return LinkedElementType.AREA_ELEMENT;
  }
}

export function isEmpty(v: any): boolean {
  return v === null || v === undefined || v === '';
}

export function formatIsoDate(iso: string): string {
  if (!iso) return '-';

  const [y, m, d] = iso.split('-');
  return `${m}.${d}.${y.slice(-2)}`;
}

export function getTaskTypeLabelMap(project: Project): Map<TaskType, string> {
  return new Map<TaskType, string>([
    [TaskType.PROJECT_TASK, 'Project Task'],
    [TaskType.FLOOR_TASK, `${project?.floorCustomName || 'Floor'} Task`],
    [TaskType.UNIT_TASK, `${project?.unitCustomName || 'Unit'} Task`],
    [TaskType.ROOM_TASK, `${project?.roomCustomName || 'Room'} Task`],
    [TaskType.AREA_TASK, `${project?.areaCustomName || 'Area'} Task`],
    [TaskType.GENERAL_TASK, 'General Task'],
  ]);
}

export function getLinkedElementTypeLabelMap(project: Project): Map<LinkedElementType, string> {
  return new Map<LinkedElementType, string>([
    [LinkedElementType.PROJECT_ELEMENT, "Project"],
    [LinkedElementType.FLOOR_ELEMENT,  `${project?.floorCustomName || 'Floor'}`],
    [LinkedElementType.UNIT_ELEMENT, `${project?.unitCustomName || 'Unit'}`],
    [LinkedElementType.ROOM_ELEMENT, `${project?.roomCustomName || 'Room'}`],
    [LinkedElementType.AREA_ELEMENT, `${project?.areaCustomName || 'Area'}`],
  ]);
}

//Check elements parent date

export function isInvalidDateTask(task: Task): boolean {
  if (!task.dueDate || !task.parentDueDate) return false;

  return parseDateOnly(String(task.dueDate)) > parseDateOnly(task.parentDueDate);
}

function parseDateOnly(iso: string): number {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d).getTime();
}

function formatDuration(days: number | null): string {
  if (days === null) {
    return '';
  }

  return days === 1 ? `${days} day` : `${days} days`;
}

export function getDurationInDays(start: string | null, end: string | null, element?: any) {
  if (!start || !end) {
    return null;
  }

  if (isProject(element) && element.effStartDate && element.effEndDate) {
    const startDate = new Date(element.effStartDate);
    const endDate = new Date(element.effEndDate);
    const diffMs = endDate.getTime() - startDate.getTime();
    const durationDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    return formatDuration(durationDays);
  } else if (!isProject(element)) {
    const startDate = new Date(start);
    const endDate = new Date(end);

    const diffMs = endDate.getTime() - startDate.getTime();
    const durationDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    return formatDuration(durationDays);
  } else {
    return null;
  }
}

